"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3335 12.9895C16.9414 11.9132 18 10.0802 18 8c0-3.3137-2.6863-6-6-6S6 4.6863 6 8c0 2.0805 1.0589 3.9136 2.6671 4.9899l-2.126 7.2289 1.514 1.1142 3.9453-2.6302 3.9453 2.6302 1.514-1.1142-2.1262-7.2293zM16 8c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4zm-2.5089 5.8133A6.013 6.013 0 0 1 12 14a6.012 6.012 0 0 1-1.4904-.1866l-1.273 4.3281 2.7638-1.8424 2.7637 1.8424-1.273-4.3282z"
  })];
};
exports.default = _default;